import { ANIMATION_STATE } from "../consts";
class WalkingState {
    name;
    animationController;
    /** The walking state, usually between the idle and runing state. */
    constructor(animationController) {
        this.name = ANIMATION_STATE.WALK;
        this.animationController = animationController;
    }
    /**
     * Enter the walking state. Handle interpolation between different states.
     * @param previousState The state from which we entered. If none is provded, the animation is just played normally.
     */
    enter(previousState) {
        const currentAction = this.animationController.getAnimations[this.name].action;
        if (!previousState) {
            currentAction.play();
            return;
        }
        const previousAction = this.animationController.getAnimations[previousState.name].action;
        currentAction.enabled = true;
        if (previousState.name === ANIMATION_STATE.RUN) {
            const ratio = currentAction.getClip().duration / previousAction.getClip().duration;
            currentAction.time = previousAction.time * ratio;
        }
        else {
            currentAction.time = 0.0;
            currentAction.setEffectiveTimeScale(1.0);
            currentAction.setEffectiveWeight(1.0);
        }
        currentAction.crossFadeFrom(previousAction, 0.5, true);
        currentAction.play();
    }
    /**
     * Exit the walking state.
     */
    exit() { }
    /**
     * Perform an update on the walking state
     * @param deltaTime The current value of the delta timer.
     * @param input A character controller input.
     * @param setState A function that changes the states of the finite state machine.
     */
    update(deltaTime, input, setState) {
        if (input.getFORWARD || input.getBACK) {
            if (input.getRUNNING) {
                setState(ANIMATION_STATE.RUN);
            }
            return;
        }
        setState(ANIMATION_STATE.IDLE);
    }
}
export { WalkingState };
